// Founder Graph shim — re-export Bootpreneurs' existing i18next instance and
// register the EN/FR `community` namespace bundles shipped with Founder Graph.
import i18n from "@/i18n";
import enCommunity from "@/locales/en/community.json";
import frCommunity from "@/locales/fr/community.json";

if (!i18n.hasResourceBundle("en", "community")) {
  i18n.addResourceBundle("en", "community", enCommunity, true, true);
}
if (!i18n.hasResourceBundle("fr", "community")) {
  i18n.addResourceBundle("fr", "community", frCommunity, true, true);
}

export default i18n;
